const observer = new MutationObserver(function (mutations, obs) {
  const wishlistRow = document.querySelector('.wishlist-row');
  if (!wishlistRow) return;

  wishlistRow.querySelectorAll('.wihslist-meta').forEach(meta => {
    if (meta.dataset.wrapped) return; // prevent double-wrapping
    
    const variantTitle = meta.querySelector('.wishlist-variant');
    const advancedOption = meta.querySelector('.wishlist-advanced-option');

    if (variantTitle && advancedOption) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('wishlist-variant-wrap');

      variantTitle.parentNode.insertBefore(wrapper, variantTitle);
      wrapper.appendChild(variantTitle);
      wrapper.appendChild(advancedOption);

      meta.dataset.wrapped = 'true'; // mark as done
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });